module.exports = __webpack_public_path__ + "static/media/index.e719a6ad.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/index.md
// module id = 1101
// module chunks = 0